import PartialAuth from './partial-auth';

export default PartialAuth;
